/**
 * DecorativeItems
 */
class DecorativeItems extends HTMLElement {
  constructor() {
    super();

    this.parentSection = this.closest('.shopify-section');
    this.svgsToAnimate = this.querySelectorAll('[data-deco-svg]');

    if (this.svgsToAnimate.length === 0) return;

    this.isInView = false;
    this.updateParallax = this.updateParallax.bind(this);

    this.parallaxObserver();
  }

  parallaxObserver() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.isInView = true;
          window.addEventListener('scroll', this.updateParallax);
          this.updateParallax();
        }
        else {
          this.isInView = false;
          window.removeEventListener('scroll', this.updateParallax);
        }
      });
    });

    observer.observe(this.parentSection);
  }

  updateParallax() {
    if (!this.isInView) return;

    const scrollY = window.pageYOffset;
    const sectionTop = this.parentSection.offsetTop;
    const sectionHeight = this.parentSection.offsetHeight;
    const windowHeight = window.innerHeight;

    const scrollProgress = (scrollY - sectionTop + windowHeight) / (sectionHeight + windowHeight);

    if (scrollProgress >= 0 && scrollProgress <= 1) {
      const movement = (scrollProgress - 0.5) * 200;

      this.svgsToAnimate.forEach((svg, index) => {
        svg.style.transform = `translate(-50%, -50%) translateY(${movement * (index + 1) * 0.6 * -1}px)`;
      });
    }
  }
}

if (!customElements.get('decorative-items')) {
  customElements.define('decorative-items', DecorativeItems);
}
